import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import Removebutton from '@mui/icons-material/RemoveCircle';
import { useStateIfMounted } from 'use-state-if-mounted';
import {
    actualizarFC_33Estatus, resetDataFC_33, agregarMapFC_33Accion,
    obtenerIdCliente, actualizarFC_33Solicitud, actualizarFC_33SolicitudMap,
    obtenerSolicitudDetalleFC_33ConMaps, aceptarSolicitudFC_33, generarDocumentosFC_33,
    actualizarFC_33SolicitudModal
} from '../../../redux/DucksAtencionACliente/FC_33AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaAtencionACliente from '../../App/TablaAtencionACliente';
import TablaDocumentacion from '../../App/TablaDocumentacion';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import BotonDescargarArchivos from '../../App/BotonDescargarArchivos';
import estilos from './AtencionAClientesFC_33Component.module.css';
import Tooltip from '@mui/material/Tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faXmark,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faXmark,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster)
import estilosFC33 from './AtencionAClientesFC_33Component.module.css'; { {/*Estilos para el componente*/ } }
import FormularioDocumentacionFC_33 from '../../UsuarioBeneficiario/FormularioFC33/FormularioDocumentacionFC_33';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';

const { useState, useEffect, useRef } = React;
const styleCorrecto = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(90%, -35%)',
    width: 350,
    height: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 3,
    p: 3,
    // background:'black',
    opacity: 1,
    'overflowY': 'scroll',
};
const styleIncorrecto = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(100%, -10%)',
    width: 330,
    height: 220,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 3,
    'overflowY': 'scroll',
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
function FC_33Component(props) {
    const [contador, setContador] = React.useState(1)
    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    const formato = useSelector(store => store.AtencionSolicitud.formato)
    let fc_33Map = useSelector(store => store.FC_33Solicitud.fc_33Map)
    let fc_33ProductosMap = useSelector(store => store.FC_33SolicitudAtencionACliente.productosMap)
    let filesMap = useSelector(store => store.FC_33SolicitudAtencionACliente.filesMap)
    let filesProductosMap = useSelector(store => store.FC_33SolicitudAtencionACliente.filesProductosMap)
    const modoVerDetalle = useSelector(store => store.FC_33SolicitudAtencionACliente.modoVerDetalle)
    const currentUser = useSelector(store => store.Usuario.data)
    const idUsuario = usuario.data.user[0].id
    var fechaHoy = moment().format('YYYY-MM-DD')
    let solicitud = useSelector(store => store.FC_33SolicitudAtencionACliente.data)
    let fechaVisita = solicitud.fechavisitapropuesta.substring(0, 10)
    const dataUser = useSelector(store => store.Usuario.user)

    let servicioSolicitado = []
    let documentacionGeneral = []
    {/*for(const i in solicitud.fc_33archivos){
        const {...anexo} = solicitud.fc_33archivos[i]
        let filtro = filesMap.filter(anexos => anexos.idfc_33archivos === anexo.idfc_33archivos )
        documentacionGeneral.push({
            id: uuidv4(),
            observaciones:  filtro[0]?.observacion? filtro[0]?.observacion:'',
            correcto: filtro[0]? !filtro[0]?.estatuscheck:false,
            incorrecto:  filtro[0]? filtro[0]?.estatuscheck:false,
            fechaInicio:  anexo.fechainicio ? anexo.fechainicio:'',
            fechaTermino:  anexo.fechafin  ? anexo.fechafin:'',
            estatus: 'Agregar',
            idMap:  filtro[0]? filtro[0]?.idfc33_archivomap : '',
            idfc_33archivos: anexo?.idfc_33archivos,
            tabla: 'fc_33archivos', nombreId: 'idfc33_solicitudenvasadonaciona', idSolicitud: anexo.idfc33_solicitudenvasadonaciona,
            nameid: anexo.nameid, nameDoc: anexo.nameid==='DGJE'?'Factura o proforma':'Orden de compra'
        })
    }*/}
    if (solicitud.maquilador) {
        servicioSolicitado.push(
            {
                id: uuidv4(), Campo: 'Tipo Instalación', valor: 'Maquilador', idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.mauilador : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.mauiladorcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.mauiladorcheck : false,
            }, {
            id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilioproducto,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.domicilioproducto : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.domicilioproductocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.domicilioproductocheck : false,
        }, {
            id: uuidv4(), Campo: 'Numero de socio', valor: solicitud.numerosocio,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.numerosocio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.numerosociocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.numerosociocheck : false,
        }, {
            id: uuidv4(), Campo: 'Responsable de instalaciones', valor: solicitud.resposableinstalaciones,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.resposableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.resposableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.resposableinstalacionescheck : false,
        }, {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.telefonocheck : false,
        }, {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronico,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.correoelectronicocheck : false,
        })
    }
    if (solicitud.propia) {
        let cortarResponsable = solicitud.resposableinstalaciones.split('/')

        servicioSolicitado.push(
            {
                id: uuidv4(), Campo: 'Tipo Instalación', valor: 'Propia', idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.propia : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.propiacheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.propiacheck : false,
            }, {
            id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilioproducto,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.domicilioproducto : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.domicilioproductocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.domicilioproductocheck : false,
        }, {
            id: uuidv4(), Campo: 'Responsable de instalaciones', valor: cortarResponsable[1],
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.resposableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.resposableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.resposableinstalacionescheck : false,
        }, {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.telefonocheck : false,
        }, {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronico,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.correoelectronicocheck : false,
        })
    }

    if (solicitud.noregistradasalida) {
        servicioSolicitado.push(
            {
                id: uuidv4(), Campo: 'Salida de una empresa no registrada', valor: solicitud.noregistradasalida === true ? 'Si' : 'No',
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.noregistradasalida : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.noregistradasalidacheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.noregistradasalidacheck : false,
            },
            {
                id: uuidv4(), Campo: 'Razón social', valor: solicitud.razonsocialsolicitante,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.razonsocialsolicitante : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.razonsocialsolicitantecheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.razonsocialsolicitantecheck : false,
            }, {
            id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilioproducto,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.domicilioproducto : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.domicilioproductocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.domicilioproductocheck : false,
        }, {
            id: uuidv4(), Campo: 'Responsable de instalaciones', valor: solicitud.resposableinstalaciones,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.resposableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.resposableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.resposableinstalacionescheck : false,
        }, {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.telefonocheck : false,
        }, {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronico,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.correoelectronicocheck : false,
        })
    }
    servicioSolicitado.push({
        id: uuidv4(), Campo: 'Entrega de hologramas', valor: solicitud.entregahologramas ? 'Si' : 'No',
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.entregahologramas : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.entregahologramascheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.entregahologramascheck : false,
    }, {
        id: uuidv4(), Campo: 'Emisión del certificado NOM para venta nacional', valor: solicitud.emicioncertificadonomparaventan ? 'Si' : 'No',
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.emicioncertificadonomparaventan : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.emicioncertificadonomparaventancheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.emicioncertificadonomparaventancheck : false,
    }, {
        id: uuidv4(), Campo: 'Inspección durante el envasado nacional', valor: solicitud.inspeccionenvasadonacional ? 'Si' : 'No',
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.inspeccionenvasadonacional : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.inspeccionenvasadonacionalcheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.inspeccionenvasadonacionalcheck : false,
    }, {
        id: uuidv4(), Campo: 'Fecha de visita propuesta', valor: fechaVisita,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.fechavisitapropuesta : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.fechavisitapropuestacheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.fechavisitapropuestacheck : false,
    }, {
        id: uuidv4(), Campo: 'Informacion adicional sobre la actividad', valor: solicitud.informacionadicionalsobreactivi,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.informacionadicionalsobreactivi : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? !fc_33Map?.informacionadicionalsobrecheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_33Map) && JSON.stringify([]) !== JSON.stringify(fc_33Map) ? fc_33Map?.informacionadicionalsobrecheck : false,
    })
    let [rowsServicioSolicitado, setRowsServicioSolicitado] = React.useState(servicioSolicitado)
    let productos = []

    for (const index in solicitud.fc_33_anexoproducto) {
        documentacionGeneral.push({ id: uuidv4(), nameDoc: 'PRODUCTO: ' + Number(Number(index) + Number(1)) })
        const { ...producto } = solicitud.fc_33_anexoproducto[index]
        let filtro = fc_33ProductosMap?.filter(anexo => anexo?.idfc33_anexoproducto === producto?.idfc33_anexoproducto)
        // let filtroMap = fc_33ProductosMap?.filter(anexo => anexo.idfc33_anexoproducto === filtro)
        productos.push(
            {
                id: uuidv4(), idfc33_anexoproducto: producto.idfc33_anexoproducto,
                idfc33_anexoproductomap: filtro[0]?.idfc33_anexoproductomap ? filtro[0]?.idfc33_anexoproductomap : '',
                contenidoalcoholico: producto.contenidoalcoholico, numeroanalisis: producto.numeroanalisis,
                numerocertificado: producto.numerocertificado, marca: producto.marca, numerolote: producto.numerolote,
                contenidonetobotella: producto.contenidonetobotella + ' ' + producto.unidad, numerobotellas: producto.numerobotellas, numerocajas: producto.numerocajas,
                tipoproducto: producto.tipoproducto,
                observaciones: filtro[0] ? filtro[0].producto : '',
                correcto: filtro[0] ? !filtro[0].productocheck : false,
                incorrecto: filtro[0] ? filtro[0].productocheck : false,
            }
        )
        let analisisLaboratorio = producto.numeroanalisis.split(',')
        let numeroCertificado = producto.numerocertificado.split(',')

        for (const i in analisisLaboratorio) {
            let nameid = `DPAL${index}${i}`.toString()
            const filtroAnalisis = solicitud.fc_33_anexoproducto[index].fc_33archivoproducto.filter(anexo => anexo.nameid === nameid)
            const filtroMapProductos = filesProductosMap?.filter(anexo => anexo?.idfc_33archivoproducto === filtroAnalisis?.[0]?.idfc_33archivoproducto)
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: filtroMapProductos[0]?.observacion ? filtroMapProductos[0]?.observacion : '',
                correcto: filtroMapProductos[0] ? !filtroMapProductos[0]?.estatuscheck : false,
                incorrecto: filtroMapProductos[0] ? filtroMapProductos[0]?.estatuscheck : false,
                fechaInicio: filtroAnalisis[0]?.fechainicio ? filtroAnalisis[0]?.fechainicio : '',
                fechaTermino: filtroAnalisis[0]?.fechafin ? filtroAnalisis[0]?.fechafin : '',
                estatus: filtroAnalisis[0]?.estatus ? filtroAnalisis[0]?.estatus : 'Agregar',
                idMap: filtroMapProductos[0]?.idfc33_archivoproductomap ? filtroMapProductos[0]?.idfc33_archivoproductomap : '',
                idfc_33archivoproducto: filtroAnalisis[0]?.idfc_33archivoproducto,
                tabla: 'fc_33archivoproducto', nombreId: 'idfc33_anexoproducto', idSolicitud: producto.idfc33_anexoproducto,
                nameid: `DPAL${index}${i}`, nameDoc: 'Análisis de Laboratorio: ' + analisisLaboratorio[i]
            })
        }
        for (const i in numeroCertificado) {
            let nameid = `DPCA${index}${i}`.toString()
            const filtroCertificado = solicitud.fc_33_anexoproducto[index].fc_33archivoproducto.filter(anexo => anexo.nameid === nameid)
            const filtroMapProductos = filesProductosMap?.filter(anexo => anexo?.idfc_33archivoproducto === filtroCertificado?.[0]?.idfc_33archivoproducto)
            documentacionGeneral.push({
                id: uuidv4(),
                observaciones: filtroMapProductos[0]?.observacion ? filtroMapProductos[0]?.observacion : '',
                correcto: filtroMapProductos[0] ? !filtroMapProductos[0]?.estatuscheck : false,
                incorrecto: filtroMapProductos[0] ? filtroMapProductos[0]?.estatuscheck : false,
                fechaInicio: filtroCertificado[0]?.fechainicio ? filtroCertificado[0]?.fechainicio : '',
                fechaTermino: filtroCertificado[0]?.fechafin ? filtroCertificado[0]?.fechafin : '',
                estatus: filtroCertificado[0]?.estatus ? filtroCertificado[0]?.estatus : 'Agregar',
                idMap: filtroMapProductos[0]?.idfc33_archivoproductomap ? filtroMapProductos[0]?.idfc33_archivoproductomap : '',
                idfc_33archivoproducto: filtroCertificado[0]?.idfc_33archivoproducto,
                tabla: 'fc_33archivoproducto', nombreId: 'idfc33_anexoproducto', idSolicitud: producto.idfc33_anexoproducto,
                nameid: `DPCA${index}${i}`, nameDoc: 'Certificado NOM de producto a granel: ' + numeroCertificado[i]
            })
        }
        let nameid = `DPJE${index}`
        const filtroEtiqueta = solicitud.fc_33_anexoproducto[index].fc_33archivoproducto.filter(anexo => anexo.nameid === nameid)
        const filtroMapEtiqueta = filesProductosMap?.filter(anexo => anexo?.idfc_33archivoproducto === filtroEtiqueta?.[0]?.idfc_33archivoproducto)
        documentacionGeneral.push({
            id: uuidv4(),
            observaciones: filtroMapEtiqueta[0]?.observacion ? filtroMapEtiqueta[0]?.observacion : '',
            correcto: filtroMapEtiqueta[0] ? !filtroMapEtiqueta[0]?.estatuscheck : false,
            incorrecto: filtroMapEtiqueta[0] ? filtroMapEtiqueta[0]?.estatuscheck : false,
            fechaInicio: filtroEtiqueta[0]?.fechainicio ? filtroEtiqueta[0]?.fechainicio : '',
            fechaTermino: filtroEtiqueta[0]?.fechafin ? filtroEtiqueta[0]?.fechafin : '',
            estatus: filtroEtiqueta[0]?.estatus ? filtroEtiqueta[0]?.estatus : 'Agregar',
            idMap: filtroMapEtiqueta[0]?.idfc33_archivoproductomap ? filtroMapEtiqueta[0]?.idfc33_archivoproductomap : '',
            idfc_33archivoproducto: filtroEtiqueta[0]?.idfc_33archivoproducto,
            tabla: 'fc_33archivoproducto', nombreId: 'idfc33_anexoproducto', idSolicitud: producto.idfc33_anexoproducto,
            nameid: `DPJE${index}`, nameDoc: 'Etiqueta aprobada'
        })
    }
    let [rowsProductos, setRowsProductos] = React.useState(productos)
    const [rowsDocumentacion, setRowsDocumentacion] = React.useState([...documentacionGeneral])






    const handdleEditPrev = (objectProducto) => {


        const filtro = rowsServicioSolicitado.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroProducto = rowsProductos.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowsDocumentacion.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtro !== -1) {
            rowsServicioSolicitado[filtro].valor = objectProducto.valor
            rowsServicioSolicitado[filtro].correcto = objectProducto.correcto
            rowsServicioSolicitado[filtro].incorrecto = objectProducto.incorrecto
            rowsServicioSolicitado[filtro].observaciones = objectProducto.observaciones
        }
        if (filtroProducto !== -1) {
            rowsProductos[filtroProducto].valor = objectProducto.valor
            rowsProductos[filtroProducto].correcto = objectProducto.correcto
            rowsProductos[filtroProducto].incorrecto = objectProducto.incorrecto
            rowsProductos[filtroProducto].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            rowsDocumentacion[filtroDocumentacion].correcto = objectProducto.correcto
            rowsDocumentacion[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowsDocumentacion[filtroDocumentacion].observaciones = objectProducto.observaciones
            rowsDocumentacion[filtroDocumentacion].fechaInicio = objectProducto.fechaInicio
            rowsDocumentacion[filtroDocumentacion].fechaTermino = objectProducto.fechaTermino
        }
    }
    const columnsProductos = [
        {
            field: 'marca', headerName: 'Marca', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 180,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.marca}`} arrow>
                        <label>{`${params.row.marca} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numeroanalisis', headerName: 'No. de analisis', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 130,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numeroanalisis}`} arrow>
                        <label>{`${params.row.numeroanalisis} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numerocertificado', headerName: 'No. de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerocertificado}`} arrow>
                        <label>{`${params.row.numerocertificado} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 100,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerolote}`} arrow>
                        <label>{`${params.row.numerolote} `}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'contenidoalcoholico', headerName: 'Alc. Vol', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 110, },
        { field: 'contenidonetobotella', headerName: 'Cont. net.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 90, },
        { field: 'numerobotellas', headerName: 'No. de botellas', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 125, },
        { field: 'numerocajas', headerName: 'No. de cajas', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 110, },

        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 110,
            renderCell: (params) =>
            (
                <Fragment>
                    <button className={params.row.correcto ? ('btn btn-success ms-1') : ('btn btn-outline-success ms-1')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                    <button className={params.row.incorrecto ? ('btn btn-danger ms-2') : ('btn btn-outline-danger ms-2')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                </Fragment>
            )
        },
    ]

    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3])
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Servicio solicitado', 'Características de productos', 'Documentación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    const [campo, setCampo] = React.useState('')
    const [valor, setValor] = React.useState('')
    const [observaciones, setObservaciones] = React.useState('')
    const [correcto, setCorrecto] = React.useState('')
    const [incorrecto, setIncorrecto] = React.useState('')
    const [id, setId] = React.useState('')
    const [rowSeleccionada, setRowSeleccionada] = React.useState(false)
    const [openModalCorrecto, setOpenModalCorrecto] = React.useState(false);
    const [documentacion, setDocumentacion] = React.useState('')
    const [estadoVigencia, setEstadoVigencia] = React.useState('')
    const [fechaInicio, setFechaInicio] = React.useState('')
    const [fechaTermino, setFechaTermino] = React.useState('')
    const [vigencia, setVigencia] = React.useState(false);
    const handleOpenModalCorrecto = (params) => {
        setId(params.row.id)
        setCorrecto(true)
        setIncorrecto(false)
        setCampo(params.row.Campo)
        setObservaciones(params.row.observaciones)
        setOpenModalCorrecto(true)
        setValor(params.row.valor)
        setFechaInicio((params.row.fechaInicio !== null && params.row.fechaInicio !== '') ? (params.row.fechaInicio) : '')
        setFechaTermino((params.row.fechaTermino !== null && params.row.fechaTermino !== '') ? (params.row.fechaTermino) : '')
        setEstadoVigencia((params.row.estatus !== null && params.row.estatus !== undefined) ? params.row.estatus : 'Agregar')
        if (params.row.tabla) {
            setRowSeleccionada(true)
            setValor(params.row.nameDoc)
        }
    }
    const handleCloseModalCorrecto = () => {
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setVigencia(false)
        setRowSeleccionada(false)
    }
    const modalComponentCorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalCorrecto}
                    onClose={handleCloseModalCorrecto}
                    hideBackdrop={true}

                >
                    <Box sx={styleCorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ color: 'black' }}>
                            <div className="form-floating mb-3" color='black'>
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "80px" }} value={valor} onChange={e => setValor(e.target.value)} />
                                {/* <input type="text" className={`form-control `} id="floatinginput" placeholder='Campo' value={valor} onChange={e => setValor(e.target.value)} /> */}
                                <label htmlFor="floatingInput">Campo</label>
                            </div>
                            <div className="form-floating mb-3">
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                                <label htmlFor="floatingInput">Observaciones</label>
                            </div>
                            <br /><br />

                        </Typography>
                        <br />
                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div >
        )
    }
    const [openModalIncorrecto, setOpenModalIncorrecto] = React.useState(false);
    const handleOpenModalIncorrecto = (params) => {
        setId(params.row.id)
        setIncorrecto(true)
        setCorrecto(false)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setObservaciones(params.row.observaciones)
        setOpenModalIncorrecto(true)
    }
    const handleCloseModalIncorrecto = () => {
        setOpenModalIncorrecto(false)

    }
    const modalComponentIncorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalIncorrecto}
                    onClose={handleCloseModalIncorrecto}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleIncorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                            <label className='text-center'>Observaciones</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                                value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                        </Typography>
                        <br />
                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CANCELAR</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const botonGuardar = () => {
        let datos = { id: id, campo: campo, correcto: correcto, incorrecto: incorrecto, observaciones: observaciones, valor: valor }
        handdleEditPrev(datos)
        handleCloseModalCorrecto(true)
        handleCloseModalIncorrecto(true)
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            Para finalizar el trámite ingrese los siguientes datos
                        </Typography>

                        <FormularioDocumentacionFC_33
                            functionAcept={botonAceptarSolicitud}
                        ></FormularioDocumentacionFC_33>

                        <br />

                    </Box>
                </Modal>
            </div>

        )
    }
    const botonAceptarSolicitud = async (dataForm) => {

        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_33Map) || JSON.stringify([]) === JSON.stringify(fc_33Map) || fc_33Map === null) {
            await agregarMapYActualizarFC_33()
        } else {
            await actualizarMapYActualizarFC_33()
        }
        const dataSolicitudFC_33 = await dispatch(obtenerSolicitudDetalleFC_33ConMaps(solicitud.idfc33_solicitudenvasadonaciona))
        const solicitudParaAceptar = dataSolicitudFC_33.payload
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            id_solicitud: "8", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: dataForm?.numeroSolicitud, origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        const objetoCompleto = {
            idcliente: dataCliente?.payload?.cliente?.[0]?.idcliente,
            idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
            productos: solicitudParaAceptar.fc_33_anexoproducto
        }
        await dispatch(aceptarSolicitudFC_33(objetoCompleto))

        let informacionmodalaceptada = {
            numerosolicitudservicios: dataForm?.numeroSolicitud,
            numcertificadonom: dataForm?.numCertificadoNOM,
            numtraslado: dataForm?.numeroTraslado,
            otrosservicios: dataForm?.otrosServicios,
            fechainspeccion: dataForm?.fechaInspeccion,
            numplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado,
            credelcialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector
        }
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        let actualizarinformacion = {
            idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
            informacionmodalaceptada: informacionmodalaceptada,
            fechaaceptada: fechaSolicitudAceptada
        }
        await dispatch(actualizarFC_33SolicitudModal(actualizarinformacion))

        await generarOficios(solicitud, dataCliente.payload.cliente[0], dataForm)

        const idSolicitud = solicitud.idfc33_solicitudenvasadonaciona
        const estatusNuevo = 4
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_33 = 7
        const tabla = tablaFC_33
        await dispatch(actualizarFC_33Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_33, dataCliente, dataForm) => {

        const data = {
            tipoSolicitud: 'FC_33',
            solicitudFC_33,
            dataCliente,
        }
        const dataSolicitudInspeccion = {
            numeroSolicitud: dataForm.numeroSolicitud,
            numCertificadoNOM: dataForm.numCertificadoNOM,
            numeroTraslado: dataForm.numeroTraslado,
            otrosServicios: dataForm.otrosServicios,
            fechaInspeccion: dataForm.fechaInspeccion,
            numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
            inspectorAsignado: dataForm.inspectorAsignado,
            credencialInspector: dataForm.credencialInspector,
            telefonoInspector: dataForm.telefonoInspector,
            checkFabrica: false,
            checkProductor: false,
            checkNacional: true,
            checkEnvasadora: false,
            checkEnvasador: false,
            checkExportacion: false,
            checkGranel: false,
            checkComercializador: false,
            checkPromocion: false,
            checkProductoTerminado: false,
            checkTraslado: false,
            checkMaduracion: false,
        }
        data.dataSolicitudInspeccion = dataSolicitudInspeccion
        await dispatch(generarDocumentosFC_33(data))
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_33Map) || JSON.stringify([]) === JSON.stringify(fc_33Map) || fc_33Map === null) {
            await agregarMapYActualizarFC_33()
            const idSolicitud = solicitud.idfc33_solicitudenvasadonaciona
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_33 = 7
            const tabla = tablaFC_33
            await dispatch(actualizarFC_33Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_33()
            const idSolicitud = solicitud.idfc33_solicitudenvasadonaciona
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_33 = 7
            const tabla = tablaFC_33
            await dispatch(actualizarFC_33Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }

    const agregarMapYActualizarFC_33 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        if (solicitud.propia) {
            principal.push({
                idfc33_solicitudenvasadonaciona: rowsServicioSolicitado[0].idfc33_solicitudenvasadonaciona,
                domicilioproducto: rowsServicioSolicitado[1].valor, //resposableinstalaciones: rowsServicioSolicitado[2].valor,
                telefono: rowsServicioSolicitado[3].valor, correoelectronico: rowsServicioSolicitado[4].valor,
                informacionadicionalsobreactivi: rowsServicioSolicitado[9].valor, //fechasolicitud: fechaSolicitudAceptada
            })
        }
        if (solicitud.maquilador) {
            principal.push({
                idfc33_solicitudenvasadonaciona: rowsServicioSolicitado[0].idfc33_solicitudenvasadonaciona,
                domicilioproducto: rowsServicioSolicitado[1].valor, numerosocio: rowsServicioSolicitado[2].valor,
                resposableinstalaciones: rowsServicioSolicitado[3].valor,
                informacionadicionalsobreactivi: rowsServicioSolicitado[10].valor, //fechasolicitud: fechaSolicitudAceptada
            })
        }
        let principalMap = []
        if (solicitud.propia) {
            principalMap.push({
                propia: rowsServicioSolicitado[0].observaciones, maquilador: '',
                domicilioproducto: rowsServicioSolicitado[1].observaciones, resposableinstalaciones: rowsServicioSolicitado[2].observaciones,
                telefono: rowsServicioSolicitado[3].observaciones, correoelectronico: rowsServicioSolicitado[4].observaciones,
                entregahologramas: rowsServicioSolicitado[5].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[8].observaciones,
                informacionadicionalsobreactivi: rowsServicioSolicitado[9].observaciones,

                propiacheck: rowsServicioSolicitado[0].incorrecto, maquiladorcheck: false,
                domicilioproductocheck: rowsServicioSolicitado[1].incorrecto, resposableinstalacionescheck: rowsServicioSolicitado[2].incorrecto,
                telefonocheck: rowsServicioSolicitado[3].incorrecto, correoelectronicocheck: rowsServicioSolicitado[4].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[5].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[8].incorrecto,
                informacionadicionalsobrecheck: rowsServicioSolicitado[9].incorrecto,
                numerosociocheck: false, numerosocio: '', idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
            })
        }
        if (solicitud.maquilador) {
            principalMap.push({
                maquilador: rowsServicioSolicitado[0].observaciones, propia: '',
                domicilioproducto: rowsServicioSolicitado[1].observaciones, numerosocio: rowsServicioSolicitado[2].observaciones,
                resposableinstalaciones: rowsServicioSolicitado[3].observaciones,
                telefono: rowsServicioSolicitado[4].observaciones, correoelectronico: rowsServicioSolicitado[5].observaciones,
                entregahologramas: rowsServicioSolicitado[6].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[10].observaciones,
                informacionadicionalsobreactivi: rowsServicioSolicitado[10].observaciones,

                maquiladorcheck: rowsServicioSolicitado[0].incorrecto, propiacheck: false,
                domicilioproductocheck: rowsServicioSolicitado[1].incorrecto, numerosociocheck: rowsServicioSolicitado[2].incorrecto,
                resposableinstalacionescheck: rowsServicioSolicitado[3].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[6].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[10].incorrecto,
                informacionadicionalsobrecheck: rowsServicioSolicitado[10].incorrecto,
                idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
            })
        }
        if (solicitud.noregistradasalida) {
            principalMap.push({
                noregistradasalida: rowsServicioSolicitado[0].observaciones, maquilador: '', propia: '',
                razonsocialsolicitante: rowsServicioSolicitado[1].observaciones,
                domicilioproducto: rowsServicioSolicitado[2].observaciones, resposableinstalaciones: rowsServicioSolicitado[3].observaciones,
                telefono: rowsServicioSolicitado[4].observaciones, correoelectronico: rowsServicioSolicitado[5].observaciones,
                entregahologramas: rowsServicioSolicitado[6].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[9].observaciones,
                informacionadicionalsobreactivi: rowsServicioSolicitado[10].observaciones,

                noregistradasalidacheck: rowsServicioSolicitado[0].incorrecto, maquiladorcheck: false, propiacheck: false,
                razonsocialsolicitantecheck: rowsServicioSolicitado[1].incorrecto,
                domicilioproductocheck: rowsServicioSolicitado[2].incorrecto, resposableinstalacionescheck: rowsServicioSolicitado[3].incorrecto,
                telefonocheck: rowsServicioSolicitado[4].incorrecto, correoelectronicocheck: rowsServicioSolicitado[5].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[6].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[9].incorrecto,
                informacionadicionalsobrecheck: rowsServicioSolicitado[10].incorrecto,
                numerosociocheck: false, numerosocio: '', idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
            })
        }

        let productosMap = []
        for (const producto of rowsProductos) {
            productosMap.push({ idfc33_anexoproductomap: producto.idfc33_anexoproductomap, producto: producto.observaciones, productocheck: producto.incorrecto, idfc33_anexoproducto: producto.idfc33_anexoproducto })
        }
        let archivosProductosMap = []

        let fechaInicio1 = ''
        let fechaFin1 = ''
        if (rowsDocumentacion[1]?.fechaInicio?.length > 0) fechaInicio1 = new Date(rowsDocumentacion[1]?.fechaInicio)?.toISOString()
        else fechaInicio1 = null
        if (rowsDocumentacion[1]?.fechaTermino?.length > 0) fechaFin1 = new Date(rowsDocumentacion[1]?.fechaTermino)?.toISOString()
        else fechaFin1 = null

        let fechaInicio2 = ''
        let fechaFin2 = ''
        if (rowsDocumentacion[2]?.fechaInicio?.length > 0) fechaInicio2 = new Date(rowsDocumentacion[2].fechaInicio)?.toISOString()
        else fechaInicio2 = null
        if (rowsDocumentacion[2]?.fechaTermino?.length > 0) fechaFin2 = new Date(rowsDocumentacion[2].fechaTermino)?.toISOString()
        else fechaFin2 = null

        for (const anexo in rowsDocumentacion) {
            let nameid = rowsDocumentacion[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPJE") {
                archivosProductosMap.push({
                    idfc33_archivoproductomap: rowsDocumentacion[anexo]?.idMap ? rowsDocumentacion[anexo]?.idMap : '',
                    estatuscheck: rowsDocumentacion[anexo]?.incorrecto, observacion: rowsDocumentacion[anexo]?.observaciones,
                    idfc_33archivoproducto: rowsDocumentacion[anexo]?.idfc_33archivoproducto,
                })
            }
        }
        let archivosProductos = []
        for (const anexo in rowsDocumentacion) {
            let nameid = rowsDocumentacion[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPJE") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowsDocumentacion[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowsDocumentacion[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowsDocumentacion[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowsDocumentacion[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosProductos.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_33archivoproducto: rowsDocumentacion[anexo]?.idfc_33archivoproducto
                })
            }
        }
        let formato = { solicitud: principal[0], archivosProductos: archivosProductos }
        let formatoMap = { solicitud: principalMap, productosMap: productosMap, archivosProductosMap: archivosProductosMap }

        await dispatch(agregarMapFC_33Accion(formatoMap))
        await dispatch(actualizarFC_33Solicitud(formato))
        return
    }

    const actualizarMapYActualizarFC_33 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        if (solicitud.propia) {
            principal.push({
                idfc33_solicitudenvasadonaciona: rowsServicioSolicitado[0].idfc33_solicitudenvasadonaciona,
                domicilioproducto: rowsServicioSolicitado[1].valor, //resposableinstalaciones: rowsServicioSolicitado[2].valor,
                telefono: rowsServicioSolicitado[3].valor, correoelectronico: rowsServicioSolicitado[4].valor,
                informacionadicionalsobreactivi: rowsServicioSolicitado[9].valor, //fechasolicitud: fechaSolicitudAceptada
            })
        }
        if (solicitud.maquilador) {
            principal.push({
                idfc33_solicitudenvasadonaciona: rowsServicioSolicitado[0].idfc33_solicitudenvasadonaciona,
                domicilioproducto: rowsServicioSolicitado[1].valor, numerosocio: rowsServicioSolicitado[2].valor,
                resposableinstalaciones: rowsServicioSolicitado[3].valor,
                informacionadicionalsobreactivi: rowsServicioSolicitado[9].valor, //fechasolicitud: fechaSolicitudAceptada
            })
        }
        let principalMap = []
        if (solicitud.propia) {
            principalMap.push({
                propia: rowsServicioSolicitado[0].observaciones, maquilador: '',
                domicilioproducto: rowsServicioSolicitado[1].observaciones, resposableinstalaciones: rowsServicioSolicitado[2].observaciones,
                telefono: rowsServicioSolicitado[3].observaciones, correoelectronico: rowsServicioSolicitado[4].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[8].observaciones,
                informacionadicionalsobreactivi: rowsServicioSolicitado[9].observaciones,

                propiacheck: rowsServicioSolicitado[0].incorrecto, maquiladorcheck: false,
                domicilioproductocheck: rowsServicioSolicitado[1].incorrecto, resposableinstalacionescheck: rowsServicioSolicitado[2].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[5].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[8].incorrecto,
                informacionadicionalsobrecheck: rowsServicioSolicitado[9].incorrecto,
                idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona, numerosociocheck: false, numerosocio: ''
            })
        }
        if (solicitud.maquilador) {
            principalMap.push({
                maquilador: rowsServicioSolicitado[0].observaciones, propia: '',
                domicilioproducto: rowsServicioSolicitado[1].observaciones, numerosocio: rowsServicioSolicitado[2].observaciones,
                resposableinstalaciones: rowsServicioSolicitado[3].observaciones,
                telefono: rowsServicioSolicitado[4].observaciones, correoelectronico: rowsServicioSolicitado[5].observaciones,
                entregahologramas: rowsServicioSolicitado[6].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[10].observaciones,
                informacionadicionalsobreactivi: rowsServicioSolicitado[10].observaciones,

                maquiladorcheck: rowsServicioSolicitado[0].incorrecto, propiacheck: false,
                domicilioproductocheck: rowsServicioSolicitado[1].incorrecto, numerosociocheck: rowsServicioSolicitado[2].incorrecto,
                resposableinstalacionescheck: rowsServicioSolicitado[3].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[6].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[10].incorrecto,
                informacionadicionalsobrecheck: rowsServicioSolicitado[10].incorrecto,
                idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
            })
        }
        if (solicitud.noregistradasalida) {
            principalMap.push({
                noregistradasalida: rowsServicioSolicitado[0].observaciones, maquilador: '', propia: '',
                razonsocialsolicitante: rowsServicioSolicitado[1].observaciones,
                domicilioproducto: rowsServicioSolicitado[2].observaciones, resposableinstalaciones: rowsServicioSolicitado[3].observaciones,
                telefono: rowsServicioSolicitado[4].observaciones, correoelectronico: rowsServicioSolicitado[5].observaciones,
                entregahologramas: rowsServicioSolicitado[6].observaciones,
                fechavisitapropuesta: rowsServicioSolicitado[9].observaciones,
                informacionadicionalsobreactivi: rowsServicioSolicitado[10].observaciones,

                noregistradasalidacheck: rowsServicioSolicitado[0].incorrecto, maquiladorcheck: false, propiacheck: false,
                razonsocialsolicitantecheck: rowsServicioSolicitado[1].incorrecto,
                domicilioproductocheck: rowsServicioSolicitado[2].incorrecto, resposableinstalacionescheck: rowsServicioSolicitado[3].incorrecto,
                telefonocheck: rowsServicioSolicitado[4].incorrecto, correoelectronicocheck: rowsServicioSolicitado[5].incorrecto,
                entregahologramascheck: rowsServicioSolicitado[6].incorrecto,
                fechavisitapropuestacheck: rowsServicioSolicitado[9].incorrecto,
                informacionadicionalsobrecheck: rowsServicioSolicitado[10].incorrecto,
                numerosociocheck: false, numerosocio: '', idfc33_solicitudenvasadonaciona: solicitud.idfc33_solicitudenvasadonaciona,
            })
        }

        let productosMap = []
        for (const producto of rowsProductos) {
            productosMap.push({ idfc33_anexoproductomap: producto.idfc33_anexoproductomap, producto: producto.observaciones, productocheck: producto.incorrecto, idfc33_anexoproducto: producto.idfc33_anexoproducto })
        }
        let archivosProductosMap = []
        for (const anexo in rowsDocumentacion) {
            let nameid = rowsDocumentacion[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPJE") {
                archivosProductosMap.push({
                    idfc33_archivoproductomap: rowsDocumentacion[anexo]?.idMap ? rowsDocumentacion[anexo]?.idMap : '',
                    estatuscheck: rowsDocumentacion[anexo]?.incorrecto, observacion: rowsDocumentacion[anexo]?.observaciones,
                    idfc_33archivoproducto: rowsDocumentacion[anexo]?.idfc_33archivoproducto,
                })
            }
        }
        let archivosProductos = []
        for (const anexo in rowsDocumentacion) {
            let nameid = rowsDocumentacion[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPJE") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowsDocumentacion[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowsDocumentacion[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowsDocumentacion[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowsDocumentacion[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosProductos.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_33archivoproducto: rowsDocumentacion[anexo]?.idfc_33archivoproducto
                })
            }
        }

        const formato = { solicitud: principal[0], archivosProductos: archivosProductos }
        const formatoMap = { idfc33_envasadonacionamap: fc_33Map.idfc33_envasadonacionamap, solicitud: principalMap, productosMap: productosMap, archivosProductosMap: archivosProductosMap }
        await dispatch(actualizarFC_33Solicitud(formato))
        await dispatch(actualizarFC_33SolicitudMap(formatoMap))
        return true
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_33())
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Servicio solicitado' ?
                    <div className='row justify-content-center'>
                        <div className='col-md-10'>
                            <TablaAtencionACliente rows={rowsServicioSolicitado} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div>
                    : nombresParaPaginas[paginaActiva - 1] === 'Características de productos' ?
                        <div className='row justify-content-center'>
                            <div className='col-10' >
                                <div style={{ height: (130 + (rowsProductos?.length * 50)), width: '103%', color: 'black' }}>
                                    <DataGrid
                                        rows={rowsProductos}
                                        columns={columnsProductos}

                                        sx={{
                                            boxShadow: 0,
                                            color: 'black',
                                            border: 0,
                                            '& .MuiDataGrid-cell': {
                                                display: 'block',
                                                position: 'relative',
                                                textAlign: 'center',
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        : nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                            <Fragment>
                                <div className='row justify-content-center'>
                                    <div className='col-12' style={{ marginLeft: '7%' }}>
                                        <TablaDocumentacion rows={rowsDocumentacion} api={{ handdleEditPrev }}></TablaDocumentacion>
                                    </div>
                                </div>

                                {modoVerDetalle ?
                                    <div className="row text-center">
                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                        </div>
                                    </div>
                                    :
                                    <div className="row text-center mt-4 mb-4">
                                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar} >Aceptar solicitud</button>
                                        </div>

                                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonDevolverSolicitud} >Devolver solicitud</button>
                                        </div>
                                    </div>
                                }
                            </Fragment>
                            : ''
            }
            {modalComponentAceptar()}
            {modalComponentCorrecto()}
            {modalComponentIncorrecto()}
        </Fragment >
    )
}

export default withRouter(FC_33Component)
